var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiningIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01507 1.07055C8.12579 1.00308 8.25852 0.982978 8.38386 1.01468L11.6936 1.85114C11.944 1.91442 12.1004 2.16348 12.0554 2.41721C14.3594 3.51094 16.0752 5.31263 16.7473 7.33971C16.8188 7.55524 16.7358 7.79237 16.5464 7.91417C16.357 8.03596 16.1101 8.01096 15.9481 7.85359C14.7684 6.70702 13.2251 5.70871 11.4244 4.98737L11.4002 5.08587C11.3689 5.21298 11.2891 5.3223 11.1783 5.38977C11.0676 5.45725 10.9349 5.47734 10.8095 5.44565L10.3366 5.32615L9.45248 8.92069C9.71364 8.98669 9.87253 9.25472 9.8074 9.51948L7.56754 18.6255C7.53635 18.7527 7.45653 18.862 7.34572 18.9294C7.23491 18.9969 7.10227 19.017 6.97684 18.9854L4.61278 18.3878C4.35165 18.3219 4.19274 18.0538 4.25785 17.7891L6.49774 8.68301C6.52892 8.55588 6.60874 8.44652 6.71955 8.37904C6.83036 8.31157 6.963 8.29151 7.08843 8.32323L7.97258 4.72868L7.49971 4.60918C7.23862 4.54319 7.07966 4.27512 7.14476 4.01043L7.16903 3.91193C5.24496 3.69191 3.41988 3.83892 1.84726 4.28994C1.63143 4.35184 1.40178 4.25639 1.29095 4.05872C1.18011 3.86104 1.21673 3.61221 1.37964 3.45592C2.91192 1.9859 5.26136 1.21159 7.80222 1.34229C7.83828 1.22897 7.91371 1.13227 8.01507 1.07055Z",
    stroke: "#118F84",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiningIndustry);
export default __webpack_public_path__ + "static/media/MINING_INDUSTRY.2a6777dab999b795d621142ccbad6eae.svg";
export { ForwardRef as ReactComponent };